module.exports = __webpack_public_path__ + "static/f7-d38c11215d66099e06cc1365d8c2460e.jpeg";